module.exports = __webpack_public_path__ + "img/logo-white.f2e292ac.svg";